const map = {
  // 合同签章
  contractTemplate: () => import('@/views/ContractSign/ContractTemplate'), // 合同模板
  initiatingSignature: () => import('@/views/ContractSign/InitiatingSignature'), // 发起签署（二级页面）
  listofContracts: () => import('@/views/ContractSign/ListofContracts') // 合同一览
}

export default map
